import { forwardRef } from 'react';
import { IconArrowRightRegular, Text } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/dist/tokens';
import styled from '@emotion/styled';

interface Props {
  image_url: string;
  title: string;
  description: string;
  onClick: () => void;
}
export const ExclusiveBanner = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { image_url, title, description, onClick } = props;

  return (
    <Container ref={ref} onClick={onClick}>
      <InnerContainer>
        <InfoContainer>
          <Image src={image_url} alt='전용관 진입 배너' />
          <TextContainer>
            <Text
              variant='Body_14_SemiBold'
              color='textPrimary'
              style={{ paddingBottom: 4, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
            >
              {title}
            </Text>
            <Text
              variant='Caption_12_Medium'
              color='textSecondary'
              style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
            >
              {description}
            </Text>
          </TextContainer>
        </InfoContainer>
        <IconArrowRightRegular size={20} />
      </InnerContainer>
    </Container>
  );
});

const Container = styled.div`
  padding: 0 16px;
`;

const InnerContainer = styled.div`
  padding: 8px 12px 8px 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  border: 1px solid ${vars.color.borderPrimary};
  border-radius: 4px;
  cursor: pointer;
`;

const InfoContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  flex: 1;
  min-width: 0;
`;

const TextContainer = styled.div`
  flex: 1;
  min-width: 0;
`;

const Image = styled.img`
  width: 56px;
  height: 56px;
  border-radius: 4px;
  object-fit: contain;
`;
